import { render, staticRenderFns } from "./trainingsHubCardStack.vue?vue&type=template&id=b1a30112&scoped=true"
import script from "./trainingsHubCardStack.vue?vue&type=script&lang=js"
export * from "./trainingsHubCardStack.vue?vue&type=script&lang=js"
import style0 from "./trainingsHubCardStack.vue?vue&type=style&index=0&id=b1a30112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a30112",
  null
  
)

export default component.exports